export default __webpack_public_path__ + "static/media/1920 knife block B side.c3db43c8.png";